//
//
//
//
//
//

export default {
  name: "input-search",
  data() {
    return {
      dialogValue: '',
      codeValue: '',
      index:0
    }
  },
  //typeList: 具有属性code/name的数组
  //text:'搜索栏 显示的字段'
  props:['text','typeList','code'],
  methods: {
    changeTypeChange(e){
      let data;
      if(this.typeList && this.typeList.length ){
        data=this.typeList.filter(val=>{
          if(val.code===e){
            this.dialogValue=val.name=='全部'?this.text:val.name;
            return val;
          }
        })
      }
      if(data && data.length){
        this.$emit('on-change',data[0])
      }else {
        this.$emit('on-change',-1)
      }
      // if(this.index>1){
      //
      // }else {
      //   if(this.code){
      //     let data;
      //     if(this.typeList && this.typeList.length ){
      //       data=this.typeList.filter(val=>{
      //         if(val.code===this.code){
      //           this.dialogValue=val.name=='全部'?this.text:val.name;
      //           return val;
      //         }
      //       })
      //     }
      //     if(data && data.length){
      //       this.$emit('on-change',data[0])
      //     }else {
      //       this.$emit('on-change',-1)
      //     }
      //   }
      // }
    },

  },
  created(){
    this.codeValue=this.code;
  },
  watch:{
    value(){
      this.codeValue=this.code;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/search-selector.vue